import { Box, Toolbar, Typography } from '@mui/material'
import React from 'react'
import logo from '../Image/logo.png';
import mpcst from '../Image/mpcst-logo.png';
import Login from '../Component/Login'
import Footer from "../Component/Footer";
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom'
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";

const Loginpage = () => {
     const { t } = useLanguage();
  return (
    <>
    <div className='text-Wrapper'>
    <Header/> 
        <Box>
            <Toolbar>
                <Login />
            </Toolbar>
        </Box>
        <DesktopFooter/>
        <Footer />
    </div>
    
    
    </>
  )
}

export default Loginpage
